import React from 'react';
import { useForm } from '@inertiajs/inertia-react';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import Button from '@/Components/Button';
import Error from '@/Components/Error';

export function EditSchedule({ schedule, canEdit, allowDeletion, office }) {

    const { data, setData, processing, errors, put, reset, wasSuccessful, delete: destroy } = useForm({
        'quota': schedule.quota,
        'birthday_limit': schedule.birthday_limit || office.birthday_limit,
    });

    const submit = (e) => {
        e.preventDefault();
        put(route('schedule.update', { office, schedule: schedule.id }), {
            preserveState: true,
        });
    };

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const handleDelete = e => {
        e.preventDefault();
        if (!allowDeletion) {
            alert('El cupo tiene reservas y no puede ser eliminado.');
            return;
        }
        const confirmation = window.confirm('¿Eliminar cupo?');
        if (!confirmation)
            return;
        destroy(route('schedule.delete', { office, schedule: schedule.id }));
    };

    return (
        <form onSubmit={submit} autoComplete='on' className="mx-auto px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg max-w-lg">

            <h2 className='mb-4 text-gray-900 text-lg font-bold text-left'>Datos del cupo</h2>

            <div className='grid grid-cols-2 justify-items-start gap-4'>
                <div>
                    <Label forInput="quota" value="Aforo" />
                    <Input
                        type="number"
                        min={1}
                        name="quota"
                        value={data.quota}
                        className="mt-1 block w-full max-w-xs"
                        isFocused={true}
                        required={true}
                        disabled={!canEdit}
                        handleChange={onHandleChange} />
                    <Error bind={errors.quota} />
                </div>
                <div>
                    <Label forInput="birthday_limit" value="Aforo cumpleaños" />
                    <Input
                        type="number"
                        min={1}
                        name="birthday_limit"
                        value={data.birthday_limit}
                        className="mt-1 block w-full max-w-xs"
                        isFocused={true}
                        required={true}
                        disabled={!canEdit}
                        handleChange={onHandleChange} />
                    <Error bind={errors.birthday_limit} />
                </div>
            </div>

            {canEdit &&
                (
                    <>
                        <div className='flex gap-3 justify-between sm:justify-end mt-8'>
                            <button
                                type='button'
                                onClick={handleDelete}
                                className='inline-flex items-center px-4 py-2 border border-red-900 rounded-md font-semibold text-xs text-red-900 hover:bg-red-900 hover:text-white transition ease-in-out duration-150'
                            >
                                Eliminar
                            </button>
                            <button
                                type='button'
                                onClick={e => reset()}
                                className='inline-flex items-center px-4 py-2 border border-gray-900 rounded-md font-semibold text-xs text-gray-900 hover:bg-gray-900 hover:text-white transition ease-in-out duration-150'
                            >
                                Restablecer
                            </button>
                            <Button className='' processing={processing}>
                                Guardar cambios
                            </Button>
                        </div>
                        {wasSuccessful && (
                            <div className='text-green-500 font-bold flex items-center sm:mr-auto mt-8'>
                                ¡Cupo actualizado exitosamente! 👍
                            </div>
                        )}
                    </>
                )
            }

        </form>
    );

}
